module.exports = __webpack_public_path__ + "img/switch_img1_msg2.1fd25a65.png";